import React, { useState, useEffect } from 'react'
import { Form, Button, ListGroup } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import Loader from './Loader'
import Message from './Message'
import {
  listOuterPostComments, createOuterPostComment,
  listPostComments, createPostComment,
} from '../actions/mediaActions'
import { COMMENT_CREATE_RESET } from '../constants/mediaConstants'

// type: 'post' (post della Home) oppure 'outerpost' (Forum pubblico) —
// decide solo quale coppia di action/endpoint usare, il resto è identico.
function CommentSection({ type = 'outerpost', id }) {
  const [comment, setComment] = useState('')

  const dispatch = useDispatch()

  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin

  const commentList = useSelector(state => state.commentList)
  const { loading, error, comments } = commentList

  const commentCreate = useSelector(state => state.commentCreate)
  const { loading: loadingCreate, success: successCreate, error: errorCreate } = commentCreate

  const listAction = type === 'post' ? listPostComments : listOuterPostComments
  const createAction = type === 'post' ? createPostComment : createOuterPostComment

  useEffect(() => {
    dispatch(listAction(id))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, id, type])

  useEffect(() => {
    if (successCreate) {
      setComment('')
      dispatch({ type: COMMENT_CREATE_RESET })
      dispatch(listAction(id))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successCreate, dispatch, id, type])

  const submitHandler = (e) => {
    e.preventDefault()
    if (loadingCreate) return // evita un doppio invio se il pulsante non si è ancora disabilitato a schermo
    dispatch(createAction(id, comment))
  }

  return (
    <div>
      <h4>Commenti {comments && comments.length > 0 && `(${comments.length})`}</h4>

      {loading ? <Loader />
        : error ? <Message variant="danger">{error}</Message>
        : comments.length === 0 ? <Message variant="info">Ancora nessun commento.</Message>
        :
        <ListGroup variant="flush" className="mb-4">
          {comments.map(c => (
            <ListGroup.Item key={c._id}>
              <strong>{c.user}</strong>
              {c.createdAt && (
                <span className="text-muted"> — {new Date(c.createdAt).toLocaleDateString('it-IT')}</span>
              )}
              <p className="mb-0">{c.comment}</p>
            </ListGroup.Item>
          ))}
        </ListGroup>
      }

      {errorCreate && <Message variant="danger">{errorCreate}</Message>}

      {userInfo ? (
        <Form onSubmit={submitHandler}>
          <Form.Group controlId="comment" className="mb-2">
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Scrivi un commento..."
              value={comment}
              required
              onChange={(e) => setComment(e.target.value)}
            />
          </Form.Group>
          <Button type="submit" variant="primary" size="sm" disabled={loadingCreate}>
            {loadingCreate ? 'Invio...' : 'Commenta'}
          </Button>
        </Form>
      ) : (
        <Message variant="info">
          <Link to="/login">Accedi</Link> per lasciare un commento.
        </Message>
      )}
    </div>
  )
}

export default CommentSection